import { render } from "./ScoreboardView.vue?vue&type=template&id=4fdf4db9&scoped=true"
import script from "./ScoreboardView.vue?vue&type=script&lang=js"
export * from "./ScoreboardView.vue?vue&type=script&lang=js"

import "./ScoreboardView.vue?vue&type=style&index=0&id=4fdf4db9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdf4db9"]])

export default __exports__